// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yyDB","type":"styles_type__20CpY","choices":"styles_choices__2dO4s"};